import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const dependencyTrack = defineConnector({
  identifier: "dependencyTrack",
  name: "Dependency-Track",
  tagLine: "Software composition analysis",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: ({ domain }) =>
    domain
      ? `https://${domain.replace(/\./g, "\\.")}/.*`
      : "https://.*.dependencytrack.org/.*",
  auth: (app) => headerAuth([{ name: "X-Api-Key", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Enter your Dependency-Track instance",
      items: [
        {
          kind: "input",
          label: "Instance domain",
          required: true,
          placeholder: "dtrack.your-company.com",
          target: { kind: "configuration", field: "domain" },
        },
      ],
    },
    {
      title: "Create an API key",
      items: [
        {
          kind: "markdown",
          content:
            "In Dependency-Track, go to **Administration › Access Management › Teams**, select a team, and generate an API key. See the [API docs](https://docs.dependencytrack.org/integrations/rest-api/) for details.",
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ domain }) => `https://${domain}/api/v1/project`,
  },
});
